// This file is auto-generated by @hey-api/openapi-ts
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var serializeFormDataPair = function (data, key, value) {
    if (typeof value === "string" || value instanceof Blob) {
        data.append(key, value);
    }
    else if (value instanceof Date) {
        data.append(key, value.toISOString());
    }
    else {
        data.append(key, JSON.stringify(value));
    }
};
var serializeUrlSearchParamsPair = function (data, key, value) {
    if (typeof value === "string") {
        data.append(key, value);
    }
    else {
        data.append(key, JSON.stringify(value));
    }
};
export var formDataBodySerializer = {
    bodySerializer: function (body) {
        var data = new FormData();
        Object.entries(body).forEach(function (_a) {
            var _b = __read(_a, 2), key = _b[0], value = _b[1];
            if (value === undefined || value === null) {
                return;
            }
            if (Array.isArray(value)) {
                value.forEach(function (v) { return serializeFormDataPair(data, key, v); });
            }
            else {
                serializeFormDataPair(data, key, value);
            }
        });
        return data;
    },
};
export var jsonBodySerializer = {
    bodySerializer: function (body) {
        return JSON.stringify(body, function (_key, value) {
            return typeof value === "bigint" ? value.toString() : value;
        });
    },
};
export var urlSearchParamsBodySerializer = {
    bodySerializer: function (body) {
        var data = new URLSearchParams();
        Object.entries(body).forEach(function (_a) {
            var _b = __read(_a, 2), key = _b[0], value = _b[1];
            if (value === undefined || value === null) {
                return;
            }
            if (Array.isArray(value)) {
                value.forEach(function (v) { return serializeUrlSearchParamsPair(data, key, v); });
            }
            else {
                serializeUrlSearchParamsPair(data, key, value);
            }
        });
        return data.toString();
    },
};
